// https://www.youtube.com/watch?v=xi3F2Zv91UE

import { FirebaseApp } from 'firebase/app'
import { auth } from './firebase';
import {
    addDoc,
    collection,
    getFirestore,
    onSnapshot,
} from 'firebase/firestore'
import { getFunctions, httpsCallable } from "firebase/functions";

export const getCheckoutUrl = async (
  app: FirebaseApp,
  priceId: string,
  mode: string,
  blueberries: String,
  type: String,
): Promise<string> => {
  const userId = auth.currentUser?.uid;
  if (!userId) throw new Error("User is not authenticated");
  if (!priceId) throw new Error(priceId);

  const db = getFirestore(app);
  const checkoutSessionRef = collection(
    db,
    "StipeCustomers",
    userId,
    "checkout_sessions"
  );

  const sessionData: Record<string, any> = {
    price: priceId,
    success_url: window.location.href,
    cancel_url: window.location.href,
    allow_promotion_codes: true, // Enable promotion codes
    automatic_tax: { enabled: true }, // Enable automatic tax
    metadata: {
      userId: userId, // Add userId to the metadata
      blueberries: blueberries,
      type: type,
    },
  };

  // Only add `mode` if it's defined and not an empty string
  if (mode == "payment") {
    sessionData.mode = mode;
  }

  const docRef = await addDoc(checkoutSessionRef, sessionData);

  return new Promise<string>((resolve, reject) => {
    const unsubscribe = onSnapshot(docRef, (snap) => {
      const { error, url } = snap.data() as {
        error?: { message: string };
        url?: string;
      };
      if (error) {
        unsubscribe();
        reject(new Error(`An error occurred: ${error.message}`));
      }
      if (url) {
        console.log("Stripe Checkout URL:", url);
        unsubscribe();
        resolve(url);
      }
    });
  });
};
  
export const getPortalUrl = async (
  app: FirebaseApp
): Promise<string> => {
  const user = auth.currentUser;

  let dataWithUrl: any;
  try {
    const functions = getFunctions(app, "us-west2");
    const functionRef = httpsCallable(
      functions,
      "ext-firestore-stripe-payments-createPortalLink"
    );
    const { data } = await functionRef({
      customerId: user?.uid,
      returnUrl: window.location.href,
    });

    // Add a type to the data
    dataWithUrl = data as { url: string };
    console.log("Reroute to Stripe portal: ", dataWithUrl.url);
  } catch (error) {
    console.error(error);
  }

  return new Promise<string>((resolve, reject) => {
    if (dataWithUrl.url) {
      resolve(dataWithUrl.url);
    } else {
      reject(new Error("No url returned"));
    }
  });
};